<template>
  <div>
    <section class="aisee-wrapper">
      <div v-if="showComplaint" class="aisee-item" @click="handleOpenComplaint">
        <img width="24px" height="24px" src="@/assets/images/cp.png" alt="">
        <p>版权投诉</p>
      </div>
      <div class="aisee-item" @click="handleOpenFeedback">
        <img width="24px" height="24px" src="@/assets/images/advise.png" alt="">
        <p>提出建议</p>
      </div>
    </section>

    <el-dialog
      v-if="showFeedback"
      title="我要反馈"
      :visible.sync="showFeedback"
      @close="showFeedback = false"
    >
      <iframe :src="url" frameborder="0" width="100%" height="555px" />
    </el-dialog>
  </div>
</template>

<script>
import { detect } from 'detect-browser'
import { mapGetters } from 'vuex'
import { ls } from '@/utils/index'
import commonService from '@/api/common'

export default {
  name: 'Feedback',
  props: {
    showComplaint: Boolean
  },
  data() {
    return {
      showFeedback: false,
      url: ''
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
    hasLogin() {
      return !!this.userInfo.openId
    },
  },
  created() {
    const browser = detect()
    if (browser) {
      this.browser = browser
    }
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.feedbackFinish)
  },
  methods: {
    init() {
      window.addEventListener('message', this.feedbackFinish)
    },
    feedbackFinish(event) {
      const origin = event.origin || event.originalEvent.origin
      if (origin !== 'https://kg.qq.com') {
        return
      }

      if (event.data?.payload?.query?.id) {
        this.showFeedback = false
      }
    },
    async getEncryptionData() {
      const userInfo = this.$store.state.user.userInfo
      const userName = userInfo.username || ls.getItem('username') || '未登录'
      const postData = {
        userid: userName,
        os: this.browser.os,
        brand: `${this.browser.name}-${this.browser.version}`,
        version: process.env.VUE_APP_VERSION
      }

      const result = await commonService.getAiseeUrl(postData)
      this.url = result.url
    },

    async handleOpenFeedback() {
      try {
        await this.getEncryptionData()
      } catch (error) {
        this.$message({
          error,
          type: 'error',
          message: `获取反馈页面异常！(${error.message})`
        })
      }
      this.showFeedback = true
    },

    // 如果登录，跳转到版权投诉页面，否则弹出登录框
    handleOpenComplaint() {
      if (this.hasLogin) {
        this.$router.push({ name: 'outsideCpTortList' })
      } else {
        this.$store.commit('login', true)
      }
    }
  }
}
</script>

<style>
.aisee-wrapper {
  position: fixed;
  right: 7px;
  bottom: 160px;
  width: 68px;
  max-height: 150px;
  padding: 24px 8px;
  border-radius: 15px;
  /* background-color: #F3F3F3B2; */
  background-color: #fff;
  z-index: 999;

  text-align: center;
  font-size: 12px;
  color: #000;

  .aisee-item {
    cursor: pointer;

    &:not(:first-child) {
      margin-top: 20px;
    }
  }
}
</style>
